// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"4cfc47b2","174":"450d255b","311":"24cf7e13","354":"2c262407","378":"0e8661c3","453":"4ea553a9","550":"48541d46","605":"7f05a773","725":"2f321211","741":"58db438c","755":"a5755ad4","943":"a60abf2c"}[chunkId] + ".chunk.js";
};